import { createSlice } from '@reduxjs/toolkit';
import { makeRequest } from '../components/utils';

const endPoint = "role";

export const loginSlice = createSlice({
    name: 'login',
    initialState: {

        order: null
    },
    reducers: {
        setRolList: (state, action) => {
            state.rolList = action.payload.rolList;
            if (action.payload.qty) {
                state.totalItems = action.payload.qty;
            }
        },
    }
})

export const {

} = loginSlice.actions;

export default loginSlice.reducer